module.exports = __webpack_public_path__ + "static/media/Hikvision.a2ee89c9.jpg";